function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { readContext } from './context';
import { settings } from './settings'; // This function holds the statically defined dependencies and when we
// execute it during render we merge them with the ones provided from Context

export function provideDependencies(realDeps) {
  return function () {
    if (settings.enabled) {
      // Read context and grab all the dependencies override
      // from all Providers in the tree
      var _readContext = readContext(),
          getDependencies = _readContext.getDependencies; // "this" is the js context that calls this entire function
      // so either the class of functional component


      var contextDeps = getDependencies(this); // Merge context provided dependencies with real ones

      return _objectSpread({}, realDeps, contextDeps);
    } // if nothing happens we just return the real dependencies


    return realDeps;
  };
}